export default __webpack_public_path__ + "static/technology-23d193346acbb5fa9d4fe5cd1d97460a.svg";